import { render } from "./Targets.vue?vue&type=template&id=458c49fa&scoped=true"
import script from "./Targets.vue?vue&type=script&lang=js"
export * from "./Targets.vue?vue&type=script&lang=js"

import "./Targets.vue?vue&type=style&index=0&id=458c49fa&lang=scss&scoped=true"

import exportComponent from "/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-458c49fa"]])

export default __exports__